/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const targetingOptionsDataSchema = z.object({
	cities: z.array(
		z.object({
			id: z.string(),
			name: z.string(),
			radius: z.number(),
			region: z.object({ id: z.string(), name: z.string() }).nullable(),
			country: z.object({ id: z.string(), name: z.string() }).nullable(),
		}),
	),
	countries: z.array(z.object({ id: z.string(), name: z.string() })),
	interests: z.array(z.object({ id: z.string(), name: z.string(), path: z.array(z.string()).nullable() })),
})

export type TargetingOptionsDataSchema = z.infer<typeof targetingOptionsDataSchema>
